angular.module('rjmNg.directives').directive "reRoute", [
  () ->
    restrict: "E"
    replace: false
    controllerAs: "view"
    bindToController: true
    require: "^?rjmUi"
    controller: [
      "$location"
      "$routeParams"
      "app"
      "appRoute"
      "Clients"
      "InputConnections"
      "FEATURE_TIER"
      (
        $location
        $routeParams
        app
        appRoute
        Clients
        InputConnections
        FEATURE_TIER
      ) ->

        view = @

        view.isLoading = false

        _routeGoogleAdwords = (connections) ->
          adwordsConnection = connections.filter (connection) ->
            connection.type is 'ad-words'
          if(adwordsConnection.length)
            $location.path appRoute("/magento/connect/googleAdwords/#{adwordsConnection[0].meta_id}")
          else
            $location.path appRoute("/magento/connect/googleAdwords/")

        _routeMysql = (client, connections) ->
          { properties: { has_guest_checkout, magento_version } } = client
          hasPreferences = has_guest_checkout && magento_version
          mysqlConnections = connections.filter (connection) -> 
            connection.type is 'mysql'
          if !hasPreferences
            $location.path appRoute("/magento/preferences")
          else if (mysqlConnections.length)
            $location.path appRoute("/magento/database/mysql/#{mysqlConnections[0].id}")
          else
            $location.path appRoute("/magento/database/mysql")


        view.reroute = ->

          view.isLoading = true
          # dashboard id is not explictely defined so we need to redirect to one
          # this should only happen when we are on the dashapp/ route
          mysqlConnections = null
          clientId = $routeParams.clientId
          user = app.getUser()
          Clients.get(clientId)
          .then (client) ->
            view.isLoading = false
            # Feature Tier: 1 = Basic Tier, 2 = Premium
            { properties: { is_implemented, feature_tier } } = client
            if is_implemented or app.isSupportUserSession()
              if (user.curtain is 1 and feature_tier is FEATURE_TIER.PREMIUM.toString() and not app.isSupportUserSession())
                $location.path appRoute("/settings/connection/")
              else
                defaultDash = app.getDefaultDashboard()
                $location.path appRoute("/#{defaultDash.id}") if defaultDash?
                $location.replace()
            else
              if feature_tier is FEATURE_TIER.BASIC.toString()
                InputConnections(clientId).get()
                .then (response) ->
                  if(app.isMagentoChannels())
                    _routeGoogleAdwords(response)
                  else
                    _routeMysql(client, response)
              else
                $location.path appRoute("/settings/connection/")
          .catch (error) ->
            view.isLoading = false

        view.$onInit = () ->
          view.reroute()

        view
    ]
    link: (scope, element, attributes, rjmUi) ->

      scope.$watch "view.isLoading", () ->
        rjmUi?.loadingUi "dashApp", scope.view.isLoading
]
